<form [formGroup]="editMetadataForm" (ngSubmit)="onSubmit()">
  <div class="grid-x" *ngIf="domainType === 'COUNTRY_CODE'">
    <div class="cell large-3 medium-4 small-12"><label>Country Name:</label></div>
    <div class="large-9 medium-8 small-12"><input formControlName="countryName" placeholder="Country Name"
                                                  class="input-group-custom" maxlength="200">
      <lib-whitelist-character-error [whitelistFormControl]="countryName"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-3 medium-4 small-12"><label>Type:</label></div>
    <div class="large-9 medium-8 small-12"> {{domainType | metadataHelper}} </div>
  </div>
  <div class="grid-x">
    <div class="cell large-3 medium-4 small-12"><label>Status:</label></div>
    <div class="large-9 medium-8 small-12"> {{domainStatus}} </div>
  </div>
  <div class="grid-x center">
    <div class="cell large-3 medium-4 small-12">
      <label>Description:</label>
    </div>
    <div class="large-9 medium-8 small-12"><textarea formControlName="description" placeholder="Description"
                                                     class="input-group-custom"></textarea>
      <lib-whitelist-character-error [whitelistFormControl]="description"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x center">
    <div class="cell large-3 medium-4 small-12">
      <label>Special Instructions:</label>
    </div>
    <div class="large-9 medium-8 small-12"><textarea formControlName="specialInstructions" placeholder="Special Instructions"
                                                     class="input-group-custom"></textarea>
    </div>
  </div>
  <div class="grid-x center">
    <div class="cell large-3 medium-4 small-12">
      <label>IANA Code:</label>
    </div>
    <div class="large-9 medium-8 small-12"><input formControlName="ianaCode" placeholder="IANA Code"
                                                  class="input-group-custom" maxlength="100">
      <lib-whitelist-character-error [whitelistFormControl]="ianaCode"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x center">
    <div class="cell large-3 medium-4 small-12">
      <label>Special Review:</label>
    </div>
    <div class="large-9 medium-8 small-12"><input formControlName="specialReview" id="specialReview" type="checkbox">

    </div>
  </div>
  <div class="grid-x center">
    <div class="cell large-3 medium-4 small-12">
      <label>Caretaker:</label>
    </div>
    <div class="large-9 medium-8 small-12"><input formControlName="caretaker" id="caretaker" type="checkbox">

    </div>
  </div>
  <div class="grid-x center">
    <div class="cell large-3 medium-4 small-12">
      <label>Phaseout:</label>
    </div>
    <div class="cell large-9 medium-8 small-12" style="display: flex; flex-direction: row; align-items: center">
      <input mwlFlatpickr
             [defaultValue]="defaultDate"
             [minDate]="minDate"
             formControlName="phaseout" />
    </div>
  </div>
  <div class="grid-x save-cancel-button-group">
    <button class="iana-button-cancel" (click)="cancel()">Cancel</button>
    <button class="iana-button" [disabled]="!editMetadataForm.valid" type="submit">Save</button>
  </div>
</form>

